import { apiClient } from '@/shared/api';

import type {
  AttributeCreateRequest,
  AttributeDefinition,
  AttributeOption,
  AttributeOptionInput,
  AttributeOptionUpdateRequest,
  AttributeUpdateRequest,
} from '../model/types';

const BASE = '/api/v1/catalog/attributes';

/** List the tenant's attribute dictionary (epic-catalog-004, user-story-catalog-004). */
export const listAttributes = async (): Promise<AttributeDefinition[]> =>
  (await apiClient.get<AttributeDefinition[]>(BASE)).data;

export const getAttribute = async (code: string): Promise<AttributeDefinition> =>
  (await apiClient.get<AttributeDefinition>(`${BASE}/${encodeURIComponent(code)}`)).data;

export const createAttribute = async (
  body: AttributeCreateRequest,
): Promise<AttributeDefinition> => (await apiClient.post<AttributeDefinition>(BASE, body)).data;

/** `code` and `type` are immutable — not part of the update body. */
export const updateAttribute = async (
  code: string,
  body: AttributeUpdateRequest,
): Promise<AttributeDefinition> =>
  (await apiClient.patch<AttributeDefinition>(`${BASE}/${encodeURIComponent(code)}`, body)).data;

/** Rejected with `409` if the attribute is already used by a product family or a product value — deactivate instead. */
export const deleteAttribute = async (code: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${encodeURIComponent(code)}`);
};

export const addAttributeOption = async (
  code: string,
  body: AttributeOptionInput,
): Promise<AttributeOption> =>
  (
    await apiClient.post<AttributeOption>(`${BASE}/${encodeURIComponent(code)}/options`, body)
  ).data;

export const updateAttributeOption = async (
  code: string,
  optionCode: string,
  body: AttributeOptionUpdateRequest,
): Promise<AttributeOption> =>
  (
    await apiClient.patch<AttributeOption>(
      `${BASE}/${encodeURIComponent(code)}/options/${encodeURIComponent(optionCode)}`,
      body,
    )
  ).data;

export const deleteAttributeOption = async (code: string, optionCode: string): Promise<void> => {
  await apiClient.delete(
    `${BASE}/${encodeURIComponent(code)}/options/${encodeURIComponent(optionCode)}`,
  );
};
